export const validateEmail = (email) => {
  if (!email) return false;

  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) return false;

  const domain = email.split("@")[1];

  if (domain.includes("..")) {
    return false;
  }

  return true;
};
